// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueMarkdown from 'vue-markdown'
import 'github-markdown-css/github-markdown.css'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueMarkdown)

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App />'
})



// WEBPACK FOOTER //
// ./src/main.js